module.exports = __webpack_public_path__ + "img/settings.63903963.svg";